import { Divider, MenuItem, Stack, ThemeProvider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Replay, NotesOutlined, EditOutlined } from '@mui/icons-material';
import { DeleteIcon, ForkliftIcon } from '@/assets/icons';
import { moreMenuTheme } from '@/modules/common/theme';
import { SimulationGroup } from '@thive/fddm-types';
import { Menu } from '@/modules/simulation/components/Menu';
import { DashboardMenuItem } from '../DashboardMenuItem';

type Props = {
  simulationGroup: SimulationGroup;
  onEditClick: () => void;
  onRerunClick: () => void;
  onDetailsClick: () => void;
  onDeleteClick: () => void;
};

export const GroupTopButtons = ({
  simulationGroup,
  onEditClick,
  onRerunClick,
  onDetailsClick,
  onDeleteClick,
}: Props) => {
  const { t } = useTranslation('interface');

  return (
    <Stack
      sx={{
        alignItems: 'center',
        flexDirection: 'row',
        height: '100%',
        justifyContent: 'flex-end',
        gap: 1,
      }}
    >
      <ThemeProvider theme={moreMenuTheme}>
        <Menu>
          <MenuItem disabled>
            <ForkliftIcon />
            {t('simulation.run_card.commissioning.label')}
          </MenuItem>
          <DashboardMenuItem url={simulationGroup.dashboardUrl} />
          <Divider />
          <MenuItem onClick={onDetailsClick}>
            <NotesOutlined />
            {t('simulation.run_card.details_button.label')}
          </MenuItem>
          <MenuItem
            onClick={onRerunClick}
            disabled={
              simulationGroup.status !== 'COMPLETED' &&
              simulationGroup.status !== 'PARTIALLY_COMPLETED'
            }
          >
            <Replay />
            {t('simulation.run_card.rerun_button.label')}
          </MenuItem>
          <MenuItem onClick={onEditClick}>
            <EditOutlined />
            {t('simulation.run_card.edit_button.label')}
          </MenuItem>
          <MenuItem onClick={onDeleteClick}>
            <DeleteIcon />
            {t('simulation.run_card.delete_button.tooltip')}
          </MenuItem>
        </Menu>
      </ThemeProvider>
    </Stack>
  );
};
